<template>
    <div>
        <el-form class="form" ref="form" label-width="100px">
            <el-checkbox class="checkbox" v-model="checked"></el-checkbox>
            <el-form-item label="附属图片">
                <FileInput v-model="data" accept="image/*"></FileInput>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import attributeMixin from '../../mixins/graphic/attribute'
export default {
    name: 'SubImage',
    mixins: [attributeMixin],
    components: {
        FileInput: require('@/components/FileInput').default,
    },
    data() {
        return {
            type: 'SubImage',
        }
    },
}
</script>
<style lang="scss">
.form {
    display: flex;
    align-items: center;
}
</style>